






import { Component, Vue } from 'vue-property-decorator';
import SignUpForm from '@/components/Auth/SignUpForm.vue';

@Component({
  components: {
    SignUpForm,
  },
  metaInfo() {
    return {
      title: `${this.$t('meta.signUpTitle')}`,
      htmlAttrs: {
        lang: this.$root.$i18n.locale
      },
      meta: [
        {
          name: 'description',
          content: `${this.$t('meta.signUpDescription')}`
        },
        {
          name: 'og:title',
          content: `${this.$t('meta.signUpTitle')}`
        },
        {
          name: 'og:description',
          content: `${this.$t('meta.signUpDescription')}`
        },
        {
          name: 'twitter:title',
          content: `${this.$t('meta.signUpTitle')}`
        },
        {
          name: 'twitter:description',
          content: `${this.$t('meta.signUpDescription')}`
        }
      ]
    }
  }
})
export default class SignUp extends Vue {

}
